import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import NewWindow from "react-new-window";
import { StyledButton } from "../styledComponents/CommonStyledComponents";
import {
  DepositNewStep,
  SpanCol,
} from "../styledComponents/StyledDepositDialog";
import DepositForm from "./DepositForm";
import {isMobile, isSafari} from "react-device-detect";

const DepositStepNewWindow = ({
  src,
  width,
  height,
  setDepositStep,
  setSpinner,
  requestMethod,
  requestParams,
  formAction,
}) => {
  const { t } = useTranslation("");
  const [newWindow, setNewWindow] = useState(false);
  //interval instance
  // let timer = null;

  useEffect(() => {
    const handler = (event) => {
      // console.log("FRAME EVENT: " + JSON.stringify(event));
      // console.log(typeof event.data)
      // console.log("origin" + event.origin)
      // console.log("origin 2: " + window.location.origin)
      if (event.origin === window.location.origin) {
        // console.log("same origin!");
        let data = null;
        if (typeof event.data !== "undefined") {
          try {
            data = JSON.parse(event.data);
          } catch (e) {
            data = event.data;
          }
          // console.log("DATA: " + JSON.stringify(event.data))
          if (typeof data.message !== "undefined") {
            console.log("set deposit step: " + data.message);
            setDepositStep(data.message);
          }
        }
      }
    };

    window.addEventListener("message", handler);

    // clean up
    return () => window.removeEventListener("message", handler);
  }, [setDepositStep]); // empty array => run only once

  const formwRef = useRef(null);

  useEffect(() => {
    if (formwRef.current) {
      // console.log("submit params form");
      formwRef.current.submit();
    }
  }, []);

  const showNewWindow = () => {
    setSpinner(true);
    setNewWindow(true);
  };

  const closeNewWindow = () => {
    console.log("unload")
    if(!isSafari) {
      //on safari unload is triggered for some reason before time
      setNewWindow(false);
      setDepositStep(0);
    }
    setSpinner(false);
  };

  const newWindowOpened = (w) => {
    // console.log("new window opened", w)

      const timer = setInterval(() => {
        // console.log(w)
        if(!isMobile) {
          w.focus();
        }
        if(isSafari) {
          if(w.closed) {
            setNewWindow(false);
            setDepositStep(0);
            clearInterval(timer)
          }
        }
      }, 2000)
  }

  if (newWindow) {
    return (
      <>
        <NewWindow
          name="dwindow"
          url={src ? src : null}
          center="screen"
          features={{
            width: width,
            height: height,
            menubar: "no",
            toolbar: "no",
            location: "no",
            resizable: "yes",
          }}
          onUnload={closeNewWindow}
          onBlock={(e) => {
            console.log("block", e)
          }}
          onOpen={(e) => newWindowOpened(e)}
          closeOnUnmount={true}
        >
          {formAction !== "" && (
            <DepositForm
              formMethod={requestMethod}
              formAction={formAction}
              formParameters={requestParams}
            ></DepositForm>
          )}
          {formAction === "" && <>loading...</>}
        </NewWindow>
        <DepositNewStep>
          <SpanCol
            style={{ display: "block" }}
            dangerouslySetInnerHTML={{
              __html: t(
                "label_payment_in_progress",
                "label_payment_in_progress"
              ),
            }}
          ></SpanCol>
        </DepositNewStep>

        {requestMethod !== "" && formAction === "" && (
          <form
            id="dWindowForm"
            ref={formwRef}
            method={requestMethod}
            target="dwindow"
            action={src}
          >
            {Object.keys(requestParams).map((key) => {
              // console.log("key: " + key);
              return (
                <input
                  type="hidden"
                  name={key}
                  key={key}
                  value={requestParams[key]}
                ></input>
              );
            })}
          </form>
        )}
      </>
    );
  }

  return (
    <>
      {!newWindow && (
        <DepositNewStep>
          <SpanCol
            dangerouslySetInnerHTML={{ __html: t("label_new_window_message") }}
          ></SpanCol>
          <StyledButton
            btnsm
            dangerouslySetInnerHTML={{
              __html: t("label_proceed", "label_proceed"),
            }}
            onClick={() => showNewWindow()}
          ></StyledButton>
        </DepositNewStep>
      )}
    </>
  );
};

export default DepositStepNewWindow;
